export default __webpack_public_path__ + "static/c2-d71f94af9ff7e76a7fa40c1d914c9af4.jpg";